<template>
  <Template>
    <CareersDetail />
  </Template>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import Template from "@/components/Templates/Punalur.vue";
import CareersDetail from "@/components/CareerDetail/Template3/index.vue";

export default defineComponent({
  components: {
    CareersDetail,
    Template,
  },
});
</script>
